import SpikeNavDemo from './SpikeNavDemo';
import * as subPage from './SpikeSubPage.route';

// Sub-page routes travel with the component: hosts build nav items and deep-links from
// SpikeNavDemo.routes.<page>.getPath({ basePath }) — each *.route.ts stays the single source.
export default Object.assign(SpikeNavDemo, { routes: { subPage } });
